import {h, Component} from 'preact';
import {connect} from 'react-redux';
import reduce from '../reducers';
import * as actions from '../actions';
import designService from '../service/designService';
import Renderer from '../canvas/renderer';
import constants, { MyMenusPath } from '../constants';
import {createPortal} from 'preact/compat';

export default @connect(reduce, actions)
class SaveModal extends Component {
  constructor() {
    super();

    this.state = {
      oldName: '',
      oldNameSet: false,
    };

    this.onChangeDesignName = (event) => {
      if (!this.state.oldNameSet) {
        this.setState({oldNameSet: true, oldName: this.props.designName});
      }

      this.props.setDesignName(event.target.value);
    };

    this.onChangeStatus = (event) => {
      const val = event.target.value;
      this.props.setDesignStatus(val);
    };

    this.save = (unmarkAsTemplate = false) => {
      this.props.markAsModified();

      this.props.setIsSaved(false);
      this.props.setIsSaving(true);

      designService.updateDesign({
        id: this.props.designId,
        templateId: this.props.parentId,
        html: Renderer.getPagesContent(),
        name: this.props.designName,
        size: this.props.designSize,
        type: unmarkAsTemplate ? 'design' : this.props.saveMode === 'template' || this.props.isTemplate ? 'template' : 'design',
        status: this.props.designStatus,
        hasVideo: this.props.hasVideo
      }).then(response => {
        this.props.setIsSaved(true);
        this.props.setIsSaving(false);

        if (this.props.quitAfterSaving) {
          this.props.setShowExitWarning(false);
          window.location = MyMenusPath;
        }

        this.setState({oldNameSet: false});
        if (this.props.createQRAfterSharing) {
          this.props.createQRCode();
        } else {
          this.props.onModalClose();
        }
      }).catch((err) => {
        if (err.response.status === 400) {
          window.InfoModal.show({title: 'Failed to save', body: 'This design name is already in use!'});
          this.props.setDesignName(this.state.oldName);
          this.setState({oldNameSet: false});
          return;
        }
        window.InfoModal.show({
          title: 'Whoops!',
          body: 'We failed to save your work. Please try again later!',
          acceptLabel: 'Got it',
        })
      });

      if (unmarkAsTemplate) {
        this.props.setIsTemplate(false);
      } else if (this.props.saveMode === 'template') {
        this.props.setIsTemplate(true);
      }
    }
  }

  render(props, state) {
    let title = '';

    if (props.customTitle) {
      title = props.customTitle;
    } else {
      switch (props.saveMode) {
        case 'template':
          title = 'Save as Template';
          break;
        case 'design':
          title = 'Save this Design';
          break;
        case 'sharing':
          title = 'Name before publishing';
          break;
      }
    }



    return props.open ? createPortal(<div>
      <div className="modal-back" onClick={props.onModalClose} />
      <div className="modal save-modal">
        <header>
          <h2>{title}</h2>
          {props.saveMode === 'sharing' ? <p>Give your design a name before publishing it</p> : ''}
        </header>
        <div className="content">
          <div className="form-block">
            <input type="text" placeholder="Design name..." value={props.designName} onChange={this.onChangeDesignName} onBlur={this.onChangeDesignName}/>
          </div>

          {(props.saveMode === 'template' || props.isTemplate) &&
          <div className="form-block">
            <label>Status</label>
            <select value={this.props.designStatus} onChange={this.onChangeStatus}>
              {constants.statuses.map(status =>
                <option value={status.id} className={!props.isAdmin && status.forAdmin ? 'hidden' : ''}>{status.label}</option>
              )}
            </select>
          </div>}

          {props.isTemplate &&
          <div className="form-block" style="text-align: center;">
            <a className='btn primary' onClick={() => this.save(true)}>
              Unmark as Template
            </a>
          </div>}

          <footer>
            <a className="btn decline" onClick={props.onModalClose}>Cancel</a>
            <a className="btn primary accept" onClick={() => this.save(false)}>{this.props.quitAfterSaving ? 'Save & Exit' : 'Save'}</a>
          </footer>
        </div>
      </div>
    </div>, document.getElementById('modals')) : null;

  }
}
